module.exports = __webpack_public_path__ + "static/assets/f1563261868076cb433433d8cf1d3087.png";